import Debug from '@/util/debug';
import _ from 'lodash';
import URITemplate from 'urijs/src/URITemplate';
import FullInfoBox from '@/components/full-info-box/FullInfoBox.vue';
import Loading from '@/components/loading/Loading.vue';
import { STEP_CHECKOUT } from '@/services/StepService';
import offlineCheck from '@/mixins/offline-check';
import { getDraftOnlineStatus } from '@/util/helper';

const debug = Debug('campaign-checkout');

export default {
  dependencies: [
    'draftService',
    'genericConfigService',
    'authService',
    'packageService',
  ],
  components: {
    'full-info-box': FullInfoBox,
    loading: Loading,
  },
  props: {
    campaign: Object,
  },
  mixins: [offlineCheck],
  data() {
    return {
      loading: true,
      error: null,
      saving: false,
      feature_appointed_onboarding: null,
      currentUser: null,
      package: null,
    };
  },
  computed: {
    cannotSave() {
      if (this.feature_appointed_onboarding === '1') {
        const isSuperUser = _.get(this.currentUser, 'groups', []).some(g => g.name === 'Super User');

        return !this.campaign.details.appointed_onboarding && !isSuperUser;
      }
      return false;
    },
  },
  mounted() {
    Promise.all([
      this.genericConfigService.getConfig()
        .then(c => this.feature_appointed_onboarding = c.feature_appointed_onboarding),
      this.packageService.getCampaignPackage(this.campaign, true)
        .then(p => this.package = p),
    ])
      .then(() => this.loading = false)
      .catch(err => {
        this.loading = false;
        this.error = err;
      });

    this.currentUser = this.authService.getUser();
  },
  methods: {
    save() {
      if (this.saving) {
        return;
      }
      this.saving = true;

      const campaignId = this.$route.params.id;
      const promise = !getDraftOnlineStatus(campaignId)
        // Offline draft is saved to FAM and removed from cache
        ? this.draftService.updateDraft(campaignId, this.campaign)
        : Promise.resolve(campaignId);
      promise
        .then(id => this.draftService.publish(id))
        .then(data => {
          this.campaign.currentStep = STEP_CHECKOUT;
          this.draftService.updateDraft(data.draft_id, this.campaign)
            .then(() => this.afterSave(data.campaign_code, data.customer_id));
        }).catch(err => {
          this.error = err;
          this.saving = false;
          debug.error('error while saving: %o', err);
        });
    },
    afterSave(campaignCode, customerId) {
      this.genericConfigService.getConfig()
        .then(c => c.agent_success_redirect || null)
        .then(redirectTemplate => {
          if (_.get(this, 'campaign.details.returnUrl', null)) {
            return _.get(this, 'campaign.details.returnUrl', null);
          }
          return redirectTemplate;
        })
        .then(redirectTemplate => {
          if (redirectTemplate) {
            const url = this.buildRedirectUrl(redirectTemplate, campaignCode, customerId);
            window.location.href = url;
          } else {
            this.$router.push({
              name: 'proposal',
              params: { id: this.campaign.id },
            });
          }
        });
    },
    buildRedirectUrl(template, campaignCode, customerId) {
      const params = {
        'campaign.code': campaignCode,
        'customer.remote_id': _.get(this, 'campaign.customer.remote_id', ''),
        'customer.id': customerId,
        'customer.email': _.get(this, 'campaign.customer.email', ''),
        'customer.name': _.get(this, 'campaign.customer.name', ''),
        'customer.phone': _.get(this, 'campaign.customer.phone', ''),
        'creator.id': _.get(this, 'currentUser.id', ''),
        'creator.email': _.get(this, 'currentUser.email', ''),
        mode: _.get(this, 'campaign.mode', ''),
        duration: _.get(this, 'campaign.details.duration', ''),
        'package.budget': _.get(this, 'package.budget.budget', ''),
      };

      return URITemplate(template).expand(params);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-checkout/CampaignCheckout.js